import classNames from 'classnames/bind';
import React from 'react';

import styles from './index.scss';

const cx = classNames.bind(styles);

const ViewCount = ({ stream }) => (
  <div className={`op-navigators op-live-badge op-clear ${cx('ViewCount')}`}>
    <div>
      <span className="ion-eye"> {stream.viewers}</span>
    </div>
  </div>
);

export default ViewCount;
